export default class ExtraPropertyDto {
	public id = '';
	public name = '';
	public extraName = '';
	public content = '';
	public description = '';
	public userId = '';
}